import React, { useState, useEffect } from 'react';
import {Button} from "./ui/button";
import {LogIn, Menu, MoveRight, X, FormInput} from "lucide-react";
import {Link, useNavigate, useLocation} from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import {ReactComponent as LoginIco} from "../assets/images/icons/login-ico.svg";
import {ReactComponent as RegisterIco} from "../assets/images/icons/register-ico.svg";
import DesktopLink from "@/components/header/desktopLink";
import PATHS from "../constants/Paths";
import TagManager from "react-gtm-module";

const navigationItems = [
    {
        title: "Home",
        href: PATHS.HOME,
        description: "",
    },
    {
        title: "Training",
        href: PATHS.TRAINING,
        description: "",
        subItems: [
            { title: "Fundamental Analysis", href: PATHS.TRAINING_FUNDAMENTAL_ANALYSIS },
            { title: "Technical Analysis", href: PATHS.TRAINING_TECHNICAL_ANALYSIS },
            { title: "Long Position", href: PATHS.TRAINING_LONG_POSITION },
            { title: "Short Position", href: PATHS.TRAINING_SHORT_POSITION },
        ],
    },
    {
        title: "About us",
        href: PATHS.ABOUT,
        description: "",
    },
    {
        title: "AI Assistant",
        href: PATHS.VIRTUAL_ASSISTANT,
        description: "",
    },
    {
        title: "Affiliate Program",
        href: PATHS.AFFILIATE_PROGRAM,
        description: "",
    },
    {
        title: "Pricing",
        href: PATHS.PRICING,
        description: "",
    },
    {
        title: "Support",
        href: PATHS.SUPPORT,
        description: "",
        subItems: [
            { title: "Video Tips For Beginners", href: PATHS.SUPPORT_VIDEO },
            { title: "AI Assistant Guides", href: PATHS.SUPPORT_AI },
            { title: "Online Support Guides", href: PATHS.SUPPORT_ONLINE },
            { title: "Discord Support Forum", href: PATHS.SUPPORT_DISCORD },
        ],
    },
    {
        title: "Contact",
        href: PATHS.CONTACT,
        description: "",
    },
];

export const Header = ({ isDiscount, setIsDiscount }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setOpen] = useState(false);
    const [isScrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0 || location.pathname == PATHS.PRICING) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        setScrolled(location.pathname == PATHS.PRICING);

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const handleOnClickLogin = () => {
        // navigate(PATHS.LOGIN)
        window.open(PATHS.LT_LOGIN_URL, '_blank');
    }

    const handleOnClickRegister = () => {
        // navigate(PATHS.REGISTER)
        window.open(PATHS.LT_REGISTER_URL, '_blank');
    }

    const handleCloseMobileMenu = () => {
        setOpen(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <header className={`w-full fixed top-0 left-0 ${isScrolled ? 'header-scroll' : ''}`}>
            {isDiscount && (
                <div className="discount-bar">
                    <Link to={"https://discord.com/channels/784842183530119198/1353855408908931263/1371877736238284891"} target="_blank">
                        <strong>JOIN DISCORD</strong> and <strong>GET FREE</strong>
                        <span className="break-line first">&nbsp;</span>
                        access to <strong>Locked Trade AI ASSISTANT!</strong>
                    </Link>
                    <Button onClick={() => setIsDiscount(false)}>
                        <X className="w-4 h-4"/>
                    </Button>
                </div>
            )}
            <div className="relative mx-auto min-h-20 flex gap-4 flex-row items-center justify-between px-8">
                <div className="flex lg:justify-start">
                <Link
                        to="/"
                        onClick={handleCloseMobileMenu}
                    >
                        <img src={Logo} alt="Logo" className="h-10 mr-4"/>
                    </Link>
                </div>
                <div className="flex flex-row gap-5">
                    <div id="desktop-menu-container" className="justify-end items-center lg:flex flex-row w-full" style={{ gap: '10px' }}>
                        {navigationItems.map((item) => (
                            <DesktopLink key={item.title} item={item}/>
                        ))}
                    </div>
                    <div className="flex justify-end gap-4">
                        <Button onClick={handleOnClickLogin} className="small-button white-variant" id="primary-menu-login-button">
                            Login <LoginIco className="w-4 h-4"/>
                        </Button>
                        <Button onClick={handleOnClickRegister} className="small-button gray-variant" id="primary-menu-register-button">
                            Register <RegisterIco className="w-4 h-4"/>
                        </Button>
                    </div>
                    <div id="mobile-menu-container" className="flex w-12 shrink items-end justify-end">
                        <Button onClick={() => setOpen(!isOpen)} style={{ color: '#FFF' }}>
                            {isOpen ? <X className="w-5 h-5"/> : <Menu className="w-5 h-5"/>}
                        </Button>
                        {isOpen && (
                            <div
                                className="absolute top-20 flex flex-col w-full right-0 bg-lt-dark-blue shadow-lg py-4 container gap-8">
                                {navigationItems.map((item) => (
                                    <div key={item.title}>
                                        <div className="flex flex-col gap-2">
                                            <Link
                                                to={item.href}
                                                className="flex justify-between items-center"
                                                onClick={() => {
                                                    TagManager.dataLayer({
                                                        dataLayer: {
                                                            event: 'mobile_menu_click',
                                                            link_text: item.title,
                                                            link_url: item.href
                                                        }
                                                    });
                                                    handleCloseMobileMenu();
                                                }}
                                            >
                                                <span className="text-lg text-white">{item.title}</span>
                                                <MoveRight className="w-4 h-4 stroke-1 text-muted-foreground"/>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                                <div key="login">
                                    <div className="flex flex-col gap-2">
                                        <Link
                                            to={PATHS.LT_LOGIN_URL}
                                            target="_blank"
                                            className="flex justify-between items-center"
                                            onClick={() => {
                                                TagManager.dataLayer({
                                                    dataLayer: {
                                                        event: 'mobile_menu_click',
                                                        link_text: 'Login',
                                                        link_url: PATHS.LT_LOGIN_URL
                                                    }
                                                });
                                                handleCloseMobileMenu();
                                            }}
                                        >
                                            <span className="text-lg text-white">Login</span>
                                            <MoveRight className="w-4 h-4 stroke-1 text-muted-foreground"/>
                                        </Link>
                                    </div>
                                </div>
                                <div key="register">
                                    <div className="flex flex-col gap-2">
                                        <Link
                                            to={PATHS.LT_REGISTER_URL}
                                            target="_blank"
                                            className="flex justify-between items-center"
                                            onClick={() => {
                                                TagManager.dataLayer({
                                                    dataLayer: {
                                                        event: 'mobile_menu_click',
                                                        link_text: 'Register',
                                                        link_url: PATHS.LT_REGISTER_URL
                                                    }
                                                });
                                                handleCloseMobileMenu();
                                            }}
                                        >
                                            <span className="text-lg text-white">Register</span>
                                            <MoveRight className="w-4 h-4 stroke-1 text-muted-foreground"/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};